"use strict";
(function($) {
	$(document).ready(function(){
		$('.banner-slideshow').bxSlider({
			auto: true,
			controls: false,
			mode: 'fade',
			pager: false,
			pause: 6000,
			speed: 800
		});

		//$('iframe').each(function(){
			//$(this).wrap('<div class="iframe-outer"><div class="iframe-wrap"></div></div>');
		//});

		$('iframe[src^="https://www.youtube"]').each(function(){
			$(this).attr('src', $(this).attr('src') + '?rel=0&showinfo=0');
		});

		var map = null;
		$('.banner-map').each(function(){
			map = new_map($(this));
		});

		$(document).on('click', '#menu-toggle', function(){
			console.log('ok');
			var menu = $('.main-menu .menu');
			var toggle = $(this);
			if($('.main-menu .menu:animated').length < 1){
				if(menu.is(':visible')){
					toggle.removeClass('active');
					menu.slideUp(300);
				}
				else {
					toggle.addClass('active');
					menu.slideDown(300);
				}
			}
			return false;
		});

		$('.main-menu').on('click', '.menu-item-has-children > a', function(){
			var parent = $(this).parent('li');
			var submenu = parent.children('.sub-menu');
			if(parent.children('sub-menu:animated').length < 1){
				if(submenu.is(':visible')){
					return true;
				}
				else {
					submenu.slideDown(300);
					parent.addClass('open');
					return false;
				}
			}
		});

		$('.close-questionnaire').on('click',function(){
			$('.questionnaire-overlay').fadeOut(300);
			return false;
		});

		$('#open-questionnaire').on('click',function(){
			$('.questionnaire-overlay').fadeIn(300);
			return false;
		});

		var inputs = document.querySelectorAll( '.file-input' );
		Array.prototype.forEach.call( inputs, function( input ){
			var label	 = input.parentElement.nextElementSibling,
				labelVal = label.innerHTML;

			input.addEventListener( 'change', function( e ){
				var fileName = '';
				if( this.files && this.files.length > 1 )
					fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
				else
					fileName = e.target.value.split( '\\' ).pop();

				if( fileName )
					label.innerHTML = fileName;
				else
					label.innerHTML = labelVal;
			});
		});



// Isotope Load more button
        //**
        var $container = $('.news-filter-grid').isotope({
            itemSelector: '.isotope-item',
            layoutMode: 'fitRows'
        });
        var initShow = 5; //number of items loaded on init & onclick load more button
        var counter = initShow; //counter for load more button
        var iso = $container.data('isotope'); // get Isotope instance

        loadMore(initShow); //execute function onload

        function loadMore(toShow) {
            $container.find(".hidden").removeClass("hidden");

            var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
                return item.element;
            });
            $(hiddenElems).addClass('hidden');
            $container.isotope('layout');
            //when no more to load, hide show more button, show less button show
            if (hiddenElems.length == 0) {
                $("#load-more").hide();
                $("#load-less").show();
            }
            else {
                $("#load-more").show();
                $("#load-less").hide();
            }

        }
        //append load more button and show less button
        $container.after('<div class="load-more-button"><button id="load-more" class=""> Load More</button></div>');
        $container.after('<div class="load-less-button"><button id="load-less" style="display:none;"> Show Less</button></div>');
        //when load more button clicked
        $("#load-more").click(function() {
            counter = counter + 5;
            loadMore(counter);
        });
        $("#load-less").click(function() {
            counter = initShow;
            loadMore(initShow);
        });
	});

	function new_map($el) {
		var $markers = $el.find('.marker');
		var args = {
			zoom : 16,
			center : new google.maps.LatLng(0, 0),
			mapTypeId : google.maps.MapTypeId.ROADMAP
		};

		var map = new google.maps.Map( $el[0], args);
		map.markers = [];

		$markers.each(function(){
	    	add_marker( $(this), map );
		});

		center_map(map);
		return map;
	}

	function add_marker($marker, map) {
		var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
		var marker = new google.maps.Marker({
			position: latlng,
			icon: wp_urls.template_url + '/dist/images/icons/icon_office.png',
			map: map
		});

		map.markers.push( marker );
	}

	function center_map(map) {
		var bounds = new google.maps.LatLngBounds();

		$.each( map.markers, function( i, marker ){
			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
			bounds.extend( latlng );
		});

		if( map.markers.length == 1 ){
		    map.setCenter( bounds.getCenter() );
		    map.setZoom(12);
		}
		else {
			map.fitBounds( bounds );
		}
	}
    $("#button").click(function(){
        $(".twitter-feed").toggleClass("not-hidden");
    });

            $(".Hover_div").on('click',function(){
                $('.Hover_div').removeClass('hover');
                $(this).addClass('hover');
            });

})(jQuery);